import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿En qué formato recibo el Mega Pack?',
    a: 'Todo el contenido es 100% digital en formato PDF. Accedés a una carpeta de Google Drive con todos los tomos y bonos organizados. El acceso es inmediato después del pago.'
  }, {
    q: '¿Funciona para cualquier banco argentino?',
    a: 'Sí, los protocolos y configuraciones aplican para todos los bancos que operan en Argentina y las principales billeteras virtuales como Mercado Pago, Ualá, etc.'
  }, {
    q: '¿Necesito saber de tecnología para usarlo?',
    a: 'No. Todo está explicado paso a paso con capturas de pantalla y lenguaje simple. Si sabés usar WhatsApp, podés blindar tus cuentas.'
  }, {
    q: '¿Qué hago si ya fui víctima de una estafa?',
    a: 'El Tomo 5 y 6 te guían exactamente en los pasos a seguir para documentar, denunciar y reclamar la restitución de los fondos según las normativas del BCRA.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días de garantía total. Si por cualquier motivo no estás conforme, pedís el reembolso y te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿Cómo pago?',
    a: 'A través de Mercado Pago. Podés pagar con tarjeta de crédito, débito o saldo de Mercado Pago. El pago es 100% seguro.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-28 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-63">
      <div className="max-w-[800px] w-full" data-id="element-64">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-bold text-white text-center mb-12" data-id="element-65">
          <div className="cyan-label-lines" data-id="element-66">FAQ</div>
          Preguntas frecuentes ❓
        </motion.h2>

        <div className="flex flex-col gap-4" data-id="element-67">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-card rounded-xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border border-brand-cyan' : 'border border-transparent'}`} data-id="element-68">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-69">
                  <span className="text-white font-bold pr-4" data-id="element-70">{faq.q}</span>
                  <span className={`text-brand-cyan transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-71">
                    ▼
                  </span>
                </button>
                <AnimatePresence data-id="element-72">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-73">
                      <div className="px-6 pb-5 text-gray-400 leading-relaxed" data-id="element-74">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}